export default {
	api: {
		operationSuccess: '操作成功',
		operationFailed: '操作失敗',
		errorTip: 'エラーの提示',
		successTip: '成功の提示',
		errorMessage: '操作に失敗しました、システムが異常です！',
		timeoutMessage: 'ログインがタイムアウトしました、もう一度ログインしてください！',
		apiTimeoutMessage: 'インターフェースのリクエストがタイムアウトしました、ページを更新してもう一度お試しください！',
		apiRequestFailed: 'インターフェースのリクエストが失敗しました、後でもう一度お試しください！',
		networkException: 'ネットワークに異常発生',
		networkExceptionMsg: 'ネットワーク接続を確認してください！ネットワークに異常があります',

		errMsg401: 'ユーザーに権限がありません（トークン、ユーザー名、パスワードエラー）！',
		errMsg403: 'ユーザーは認証されていますが、アクセスは禁止されています！',
		errMsg404: 'ネットワークリクエストエラー、リソースが見つかりませんでした！',
		errMsg405: 'ネットワークリクエストエラー、許可されていないリクエストメソッドです！',
		errMsg408: 'ネットワークリクエストのタイムアウトです！',
		errMsg500: 'サーバーエラー、管理者にお問い合わせください！',
		errMsg501: 'ネットワークが実装されていません！',
		errMsg502: 'ネットワークエラー！',
		errMsg503: 'サービスは利用できません、サーバーが一時的に過負荷またはメンテナンス中です！',
		errMsg504: 'ネットワークタイムアウト！',
		errMsg505: 'httpバージョンがリクエストをサポートしていません！',
	},
	app: {
		logoutTip: 'リマインダー',
		logoutMessage: 'システムを終了しますか？',
		menuLoading: 'メニューの読み込み中...',
	},
	errorLog: {
		tableTitle: 'エラーログリスト',
		tableColumnType: 'タイプ',
		tableColumnDate: '時間',
		tableColumnFile: 'ファイル',
		tableColumnMsg: 'エラーメッセージ',
		tableColumnStackMsg: 'スタック情報',

		tableActionDesc: '詳細',

		modalTitle: 'エラーの詳細',

		fireVueError: 'Vueエラーを発生させる',
		fireResourceError: 'リソースエラーを発生させる',
		fireAjaxError: 'Ajaxエラーを発生させる',

		enableMessage: 'useErrorHandle=trueの場合にのみ有効です `/src/settings/projectSetting.ts`。',
	},
	exception: {
		backLogin: 'ログインに戻る',
		backHome: 'ホームに戻る',
		subTitle403: '申し訳ありませんが、このページにアクセスする権限がありません。',
		subTitle404: '申し訳ありませんが、訪れたページは存在しません。',
		subTitle500: '申し訳ありませんが、サーバーがエラーを報告しています。',
		noDataTitle: '現在のページにはデータがありません。',
		networkErrorTitle: 'ネットワークエラー',
		networkErrorSubTitle: '申し訳ありませんが、ネットワーク接続が切断されました。ネットワークを確認してください！',
	},
	lock: {
		unlock: 'クリックして解除',
		alert: 'パスワードが正しくありません',
		backToLogin: 'ログインに戻る',
		entry: 'システムに入る',
		placeholder: 'ロック画面のパスワードまたはユーザーパスワードを入力してください',
	},
	login: {
		backSignIn: 'ログインに戻る',
		mobileSignInFormTitle: 'モバイルログイン',
		qrSignInFormTitle: 'QRコードログイン',
		signInFormTitle: 'ログイン',
		signUpFormTitle: '登録',
		forgetFormTitle: 'パスワードのリセット',

		signInTitle: '北極星バックステージ管理システム',
		signInDesc: '個人の詳細情報を入力して開始してください！',
		policy: '私はxxxのプライバシーポリシーに同意します',
		scanSign: 'コードをスキャンしてログインを完了する',

		loginButton: 'ログイン',
		registerButton: '登録',
		rememberMe: '覚えてますか',
		forgetPassword: 'パスワードをお忘れですか？',
		otherSignIn: '以下でサインイン',

		// notify
		loginSuccessTitle: 'ログインに成功',
		loginSuccessDesc: 'こんにちは！北極星 システムへようこそ',

		// placeholder
		accountPlaceholder: 'ユーザー名を入力してください',
		passwordPlaceholder: 'パスワードを入力してください',
		smsPlaceholder: 'SMSコードを入力してください',
		mobilePlaceholder: '携帯番号を入力してください',
		policyPlaceholder: 'チェックしてから登録',
		diffPwd: 'パスワードが一致しません',

		userName: 'ユーザー名',
		password: 'パスワード',
		confirmPassword: 'パスワードの確認',
		email: 'メール',
		smsCode: 'SMSコード',
		mobile: '携帯電話',

		yuanMiMa: '古いパスワード',
		xinMiMa: '新しいパスワード',
	},
	queRenMiMa: 'パスワードの確認',
	xiuGaiYongHuMiMa: 'ユーザーの現在のパスワードを変更する',
	xiTongGuanLi: 'システム管理',
	yunYingYongHuGuanLi: '運用ユーザー管理',
	keHuYongHuGuanLi: '顧客ユーザー管理',
	souSuoNeiRong: 'ユーザー管理の検索コンテンツ',
	yongHuZhangHao: 'アカウント',
	qingshuruyonghuzhanghao: 'ユーザーアカウントを入力してください',
	yongHuXingMing: '名前',
	qingshuruyongHuXingMing: 'ユーザーの名前を入力してください',
	lianXiDianHua: '電話番号',
	qingshuruyonghushoujihao: 'ユーザーの電話番号を入力してください',
	keHujiancheng: '顧客の略称',
	qingshuruyonghuzhaungtai: 'ユーザーの状態を入力してください',
	yongHuZhuangTai: '状態',
	zuiHouDengLuShiJian: '最終ログイン',
	zaiZhi: '在職',
	fuzhi: 'コピー',
	liZhi: '退職',
	xingBie: '性別',
	nan: '男性',
	nv: '女性',
	tiShi: 'ヒント',
	xuHao: '順番',
	queDingLizhi: 'このユーザーを退職に設定してもよろしいですか',
	queDingZaiZhi: 'このユーザーを在職に設定してもよろしいですか',
	queDingDelete: 'この顧客を削除してもよろしいですか',
	queDingQiyong: 'この顧客を有効にしてもよろしいですか',
	zhuangTai: '状態',
	constract: '連絡先番号',
	managerNumber: '管理者アカウント',
	chongZhiMiMa: 'パスワードのリセット',
	quedingyaofuzhigaiyonghuma: 'このユーザーをコピーしてもよろしいですか？',
	quedingyaobianjigaiyonghuma: 'このユーザーを編集してもよろしいですか？',
	quedingyaoxinzenggaiyonghuma: 'このユーザーを新規追加してもよろしいですか？',
	denglu: 'ログイン',
	workbench: 'ワークベンチ',
	analysis: '分析ページ',
	dashboard: 'ダッシュボード',
	wushuju: 'データなし',
	xianggang: '香港',
	zhongguo: '中国'
};
